import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface CountSuccessfulGenerationsByCompanyIdRequest {
    companyId: string;
}

interface CountSuccessfulGenerationsByCompanyIdResponse {
    count: number;
}


const countSuccessfulGenerationsByCompanyId = async (companyId: string): Promise<CountSuccessfulGenerationsByCompanyIdResponse> => {
    const countSuccessfulGenerationsByCompanyId = httpsCallable<CountSuccessfulGenerationsByCompanyIdRequest, any>(functions, 'count_successful_generations_by_company_id');
    const result = await countSuccessfulGenerationsByCompanyId({ companyId });

    return result.data;
};

export { countSuccessfulGenerationsByCompanyId };